module.exports = __webpack_public_path__ + "static/media/seek-start-button.1a1dd073.png";